<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="$t('应用名称')">
              <a-input v-model="queryParams.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="apps" @change="handleTableChange">
      <div slot="templateType" slot-scope="text, record">
        <ASwitch v-model="record.templateType" :checkedChildren="$t('是')" :unCheckedChildren="$t('否')" @change="v => handleTemplateTypeChange(v, record)" />
      </div>
      <div slot="status" slot-scope="text, record">
        <ASwitch v-model="record.status" :checkedChildren="$t('是')" :unCheckedChildren="$t('否')" @change="v => handleStatusChange(v, record)" />
      </div>
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleAppHome(record)">{{ $t('主页') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleAppDb(record)">{{ $t('数据源') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleAppApi(record)">{{ $t('接口管理') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleAppDesign(record)">{{ $t('设计') }}</a>    
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <AppEditModal ref="edit" @ok="handleRefresh" />
    <AppDbListModal ref="db" @ok="handleRefresh" />
    <AppApiManageModal ref="api" />
  </a-card>
</template>
<script>
import { getAppListForCurrentUser, removeApps, saveApp, releaseApp} from '@/api/app/app'
import AppEditModal from './modals/AppEditModal.vue'
import { AppThemeOptions, AppStatusOptions } from '@/constants/AppConstants'
import { getLabelFromOptions } from '@/utils/dictUtils'
import AppDbListModal from './modals/AppDbListModal.vue'
import AppApiManageModal from './modals/AppApiManageModal.vue'
import Switch from '@/components/Switch'
import RouteQueryMixins from '@/mixins/RouteQueryMixins'

export default {
  components: {
    AppEditModal,
    AppDbListModal,
    AppApiManageModal,
    ASwitch: Switch
  },
  mixins: [RouteQueryMixins],
  data() {
    return {
      queryParams: {},
      apps: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('应用名称'),
          dataIndex: 'name',
          width: 200
        },
        {
          title: this.$t('应用描述'),
          dataIndex: 'remark',
        },
        {
          title: this.$t('应用ID'),
          dataIndex: 'appId',
        },
        {
          title: this.$t('应用密钥'),
          dataIndex: 'appSecret',
        },
        {
          title: this.$t('主题'),
          dataIndex: 'theme',
          customRender: (text) => {
            return getLabelFromOptions(text, AppThemeOptions)
          }
        },
        {
          title: this.$t('是否模板'),
          dataIndex: 'templateType',
          scopedSlots: { customRender: 'templateType' }
        },
        {
          title: this.$t('是否发布'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted() {
    this.handleRefresh()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getAppListForCurrentUser({ ...params }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.apps = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleAdd() {
      this.$refs.edit.show()
    },
    handleEdit(record) {
      this.$refs.edit.show(record)
    },
    handleAppHome(record) {
      const pageKey = this.buildPageKey(record.id)
      const routeData = this.$router.resolve({ path: '/app/config', query: { pageKey } })
      window.open(routeData.href, '_blank')
    },
    handleAppDb(record) {
      this.$refs.db.show(record)
    },
    handleAppApi(record) {
      this.$refs.api.show(record)
    },
    handleAppDesign(record) {
      const pageKey = this.buildPageKey(record.id)
      const routeData = this.$router.resolve({ path: '/app/config', query: { pageKey, config: '1' } })
      window.open(routeData.href, '_blank')
    },
    handleTemplateTypeChange(v, record) {
      const updateData = {
        id: record.id,
        templateType: v
      }
      saveApp(updateData).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.message || this.$t('保存失败'))
        }
      })
    },
    handleStatusChange(v, record) {
      const updateData = {
        id: record.id,
        status: v
      }
      releaseApp(updateData).then(res => {
        if (res.code !== 0) {
          this.$message.error(res.message || this.$t('保存失败'))
        }
      })
    },
    handleDelete(record) {
      removeApps([record.id]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less" module>
.container {
  height: 100%;
  padding: 20px;
  background-color: #fff;
}
</style>